import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {Invoice} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Invoice,
        handleSubmit: (values: Invoice) => void
    }) => {

    const title = record?.id ? `Edit Invoice` : `Add Invoice`;

    const handleFormSubmit = async (values: Invoice) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-up",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
